import { Box, Divider } from "@mui/material";
import { Outlet } from "react-router";
import InboxTreeComponent from "../inboxTree/InboxTreeComponent";

export const InboxComponent = () => {
  return (
    <Box sx={{ display: "flex", width: "100%", flex: 1 }}>
      <Box sx={{ display: "flex", flexDirection: "column", width: "19rem", overflowY: "auto" }}>
        <InboxTreeComponent />
      </Box>
      <Divider orientation="vertical" />
      <Box sx={{ display: "flex", width: "100%", flex: 1, overflowY: "auto" }}>
        <Outlet />
      </Box>
    </Box>
  );
};

export default InboxComponent;
